<template>
    <div>
      <div class="col-sm-12 col-xl-6">
        <div class="form-card h-100 p-4">
          <h6 class="mb-4">Add Cron</h6>
          <form @submit.prevent="onSubmit">
            <div class="form-floating mb-3">
              <input
                type="text"
                v-model="form.name"
                name="name"
                class="form-control"
                id="name"
                placeholder="Platform Name"
              />
              <label for="name">Name</label>
            </div>
            <div class="form-floating mb-3">
              <input
                type="text"
                v-model="form.expressions"
                name="expressions"
                class="form-control"
                id="expressions"
                placeholder="Expressions"
              />
              <label for="expressions">Expressions</label>
            </div>

            <div class="form-floating mb-3">
              <input
                type="text"
                v-model="form.url"
                name="url"
                class="form-control"
                id="url"
                placeholder="Url"
              />
              <label for="url">Url</label>
            </div>

            <div class="form-floating mb-3">
              <select class="form-select" id="select-status" aria-label="Select Sector" name="status" v-model="form.status">
                  <option v-for="option in this.$helper.getBooleanOption()" :key="option.code" :value="option.code">
                    {{ option.label}}
                  </option>
              </select>
              <label for="select-status">Status</label>
            </div>

            <div class="form-floating mb-3">
              <input
                type="date"
                v-model="form.created_at"
                name="created_at"
                class="form-control"
                id="created-at"
                placeholder="Created At"
              />
            <label for="created-at">Created At</label>
            </div>
            <div class="form-floating mb-3">
              <button :disabled="v$.form.$invalid" type="submit" @click="AddCron()" class="btn btn-primary">
                Submit
              </button>
            </div>
          </form>
        </div>
    </div>
    <ReportTable title="Sector" :fields='cronFields' :data ='crons'/>
    </div>
  </template>
  
<script>

import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import { useAlertStore } from '@/stores';

import ReportTable from '@/components/Report/Table.ce.vue';

import gql from 'graphql-tag'

const CRONS_QUERY = gql`
  query Crons {
    crons {
      scheduler_crons_id
      name
      expressions
      url
      status
      created_at
    }
}`;

const ADD_CRON_QUERY = gql`
mutation AddCron($schedulerCronsId: ID, $name: String, $expressions: String, $url: String, $status: String, $createdAt: String) {
  addCron(scheduler_crons_id: $schedulerCronsId, name: $name, expressions: $expressions, url: $url, status: $status, created_at: $createdAt) {
    scheduler_crons_id
    name
    expressions
    url
    status
    created_at
  }
}`;

export default {
    name: "cron-list",
    components: {
      ReportTable
    },
    data() {
      return {
        crons: [],
        form: {
          name: "",
          expressions: "",
          url: "",
          status: "",
          created_at: "",
        },
        cronFields: 
        {
          'scheduler_crons_id' : {
            'text' : 'Cron Id',
            'type' : 'number',
          },
          'name' : {
            'text' : 'Name',
            'type' : 'text', 
          },
          'expressions' : {
            'text' : 'Expressions',
            'type' : 'text', 
          },
          'url' : {
            'text' : 'URL',
            'type' : 'text', 
          },
          'status' : {
            'text' : 'status',
            'type' : 'option',
            'options' : {'1': 'Enable', '0':'Disable'}
          },
          'created_at' : {
            'text' : 'Created At',
            'type' : 'datetime',
            'is_date_format' : true
          },
          'action': {
            'text' : 'Action',
            'type' : 'text',
            'renderer': 'scheduler/crons/Action.vue',
          },
        }
      };
    },
    validations() {
      return {
        form: {
          name: { required },
          expressions: { required },
          url: { required },
        },
      };
    },
    setup() {
      return { 
        v$: useVuelidate(),
        alertStore$: useAlertStore(),
       };
    },
    methods: {
        AddCron() {
            try {
                this.$apollo.mutate({
                    mutation: ADD_CRON_QUERY,
                    variables: {
                      "schedulerCronsId": 0,
                      "name": this.form.name,
                      "expressions": this.form.expressions,
                      "url": this.form.url,
                      "status": this.form.status,
                      "createdAt": this.form.created_at
                    },
                }).then((response) => {
                    if(response.data.addCron.scheduler_crons_id){
                      //this.crons.push(response.data.addCron);
                      //this.crons = [...this.crons, response.data.addCron];
                      this.alertStore$.success('New cron add successfully.');
                      this.form = {name: "", expressions: "", url: "", status: "", created_at: ""};
                    }
                }).catch((error) => {
                    this.alertStore$.error(JSON.stringify(error.message));
                });
            } catch (error) {
                this.alertStore$.error(JSON.stringify(error.message));
            }
        },
    },
    apollo: {
      crons: {
        query: CRONS_QUERY,
      }
    }
};
</script>

<style scoped>
.form-card {
  background: #fff;
  border: 1px solid var(--border);
  border-radius: 12px;
}
</style>